import Glide from '@glidejs/glide'
import { escapeRegExp } from 'lodash'

if (document.getElementById('js-glide')) {
  new Glide('.glide', {
    autoplay: 5000,
    animationDuration: 1000,
    animationTimingFunc: 'ease',
    perView: 1,
    type: "carousel"
  }).mount()
}